/* =========================================================
   recipe-v2.js — レシピページ v2（blog.recipe-v2 / article.recipe-v2）
   Spec: spec/recipe_v2_spec.md §8 §9 + §5-1（解凍シート）§5-5（PAIRING タブ）§5-6（newsletter tag）
   - 依存なし・defer。各 recipe-v2-* セクションから読み込む（theme.liquid には追加しない）
   - 同一ページで複数回読み込まれても二重初期化しない（window.jcRv2Loaded）
   - GA4 送信 window.jcTrack: バッチ0 の調査結果（GTM なし・gtag なし・Shopify Google & YouTube チャネルの
     Web Pixel のみ）に基づき、dataLayer.push を基本とし、gtag / Shopify.analytics.publish が存在すれば併送する
     （jc-gift-v2.js と同じ guard 付きパターン）
   ========================================================= */
(function () {
  'use strict';

  if (window.jcRv2Loaded) return;
  window.jcRv2Loaded = true;

  /* ---------- §9 送信関数 ---------- */
  function jcTrack(eventName, params) {
    params = params || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, params));
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
      }
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('jc_recipe_v2_' + eventName, params); // Web Pixel（カスタムピクセル）側で購読可能
      }
    } catch (e) { /* noop */ }
  }
  if (typeof window.jcTrack !== 'function') window.jcTrack = jcTrack;

  function parseParams(str) {
    if (!str) return {};
    try { return JSON.parse(str); } catch (e) { return {}; }
  }

  /* ---------- §9 クリック委譲（data-jc-event / data-jc-params） ---------- */
  document.addEventListener('click', function (ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest('[data-jc-event]') : null;
    if (!el) return;
    jcTrack(el.getAttribute('data-jc-event'), parseParams(el.getAttribute('data-jc-params')));
  }, true);

  /* ---------- §8 ?ref=card → cookie → cart attribute ---------- */
  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function initRef() {
    try {
      var sp = new URLSearchParams(window.location.search);
      if (sp.get('ref') === 'card') {
        document.cookie = 'jc_ref=card; max-age=2592000; path=/; SameSite=Lax';
      }
      if (getCookie('jc_ref') !== 'card') return;
      var done = false;
      try { done = window.sessionStorage.getItem('jc_ref_cart') === '1'; } catch (e) { done = false; }
      if (done) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { landing_ref: 'card' } })
      }).then(function (res) {
        if (res.ok) { try { window.sessionStorage.setItem('jc_ref_cart', '1'); } catch (e) { /* noop */ } }
      }).catch(function () { /* noop */ });
    } catch (e) { /* noop */ }
  }

  /* ---------- §5-6 newsletter: hidden tags に gift_recipient 追加 / 送信成功イベント ---------- */
  function initNewsletter(root) {
    var isCard = getCookie('jc_ref') === 'card';
    root.querySelectorAll('[data-jc-newsletter-tags]').forEach(function (input) {
      if (!isCard) return;
      var tags = (input.value || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      if (tags.indexOf('gift_recipient') === -1) tags.push('gift_recipient');
      input.value = tags.join(',');
    });
    root.querySelectorAll('[data-jc-newsletter-success]').forEach(function (el) {
      if (el.dataset.jcSent) return;
      el.dataset.jcSent = '1';
      jcTrack('newsletter_signup', { landing_ref: getCookie('jc_ref') || 'none' });
    });
  }

  /* ---------- §5-1 解凍シート（ボトムシート） ---------- */
  var lastFocus = null;
  function openSheet(sheet, from) {
    if (!sheet || sheet.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('jc-rv2-lock');
    var panel = sheet.querySelector('.jc-rv2-sheet__panel');
    if (panel) { panel.setAttribute('tabindex', '-1'); panel.focus({ preventScroll: true }); }
    jcTrack('thaw_popup_open', { from: from || 'top_s2' });
  }
  function closeSheet(sheet) {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.jc-rv2-sheet.is-open')) {
      document.documentElement.classList.remove('jc-rv2-lock');
    }
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  }
  function initSheets(root) {
    root.querySelectorAll('[data-jc-sheet-open]').forEach(function (btn) {
      if (btn.dataset.jcInit) return;
      btn.dataset.jcInit = '1';
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        openSheet(document.getElementById(btn.getAttribute('data-jc-sheet-open')), btn.getAttribute('data-jc-from'));
      });
    });
    root.querySelectorAll('.jc-rv2-sheet').forEach(function (sheet) {
      if (sheet.dataset.jcInit) return;
      sheet.dataset.jcInit = '1';
      sheet.querySelectorAll('[data-jc-sheet-close]').forEach(function (btn) {
        btn.addEventListener('click', function (ev) { ev.preventDefault(); closeSheet(sheet); });
      });
    });
  }
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape' && ev.key !== 'Esc') return;
    var open = document.querySelector('.jc-rv2-sheet.is-open');
    if (open) closeSheet(open);
  });

  /* ---------- §5-5 PAIRING タブ（URL 変更なし） ---------- */
  function initTabs(root) {
    root.querySelectorAll('[data-jc-tabs]').forEach(function (wrap) {
      if (wrap.dataset.jcInit) return;
      wrap.dataset.jcInit = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(wrap.querySelectorAll('[role="tabpanel"]'));
      function select(tab, silent) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
        });
        panels.forEach(function (p) {
          var on = p.id === tab.getAttribute('aria-controls');
          if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
        });
        if (!silent) jcTrack('filter_use', { pair: tab.getAttribute('data-jc-pair') || '' });
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (ev) {
          var next = null;
          if (ev.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (ev.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (next) { ev.preventDefault(); next.focus(); select(next, false); }
        });
      });
      var initial = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
      if (initial) select(initial, true);
    });
  }

  /* ---------- §5-1 ピル横スクロール: active ピルを見える位置へ ---------- */
  function initPills(root) {
    root.querySelectorAll('.jc-rv2-pills__row').forEach(function (row) {
      if (row.dataset.jcInit) return;
      row.dataset.jcInit = '1';
      var active = row.querySelector('.jc-rv2-pill.is-active');
      if (!active || row.scrollWidth <= row.clientWidth) return;
      var left = active.offsetLeft - (row.clientWidth - active.offsetWidth) / 2;
      row.scrollLeft = Math.max(0, left);
    });
  }

  function init(root) {
    root = root || document;
    initSheets(root);
    initTabs(root);
    initPills(root);
    initNewsletter(root);
  }

  function boot() {
    init(document);
    initRef();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (ev) { init(ev.target || document); });
})();
